import { SubAPI } from "./SubAPI";
import {OpeningType} from "./Products";

export class Keying2 extends SubAPI {
    list(props: {
        project: number;
    }) {
        return this.fetcher.get<Keying2Config>("/api/keying2", props);
    }

    update(input: Keying2Config) {
        return this.fetcher.post("/api/keying2", input);
    }

    updateShortcodeDetailed(input: Keying2Shortcode) {
        return this.fetcher.post<{ id: number }>("/api/keying2/shortcode/detailed", input);
    }

    upsertShortcode(input: Keying2Shortcode & {
        addOpening?: number;
        addMiscProduct?: number;
    }) {
        return this.fetcher.post<{ id: number }>("/api/keying2/shortcode", input);
    }

    searchOpenings(input: {
        project: number;
        search: string;
    }) {
        return this.fetcher.get<Keying2Opening[]>("/api/keying2/openings/search", input)
    }

    upsertProducts(input: Keying2Product[]) {
        return this.fetcher.post("/api/keying2/products", input);
    }

    upsertLink(input: {
        shortcode: number;
        project: number;
        addOpening?: number;
        addOpenings?: number[];
        removeOpening?: number;
        addMiscProduct?: number;
        addMiscProducts?: number[];
        removeMiscProduct?: number;
    }) {
        return this.fetcher.post("/api/keying2/link", input);
    }

    getPending(props: {
        project: number;
        includeUnkeyed?: boolean;
    }) {
        return this.fetcher.get<Keying2PendingItem[]>("/api/keying2/pending", props);
    }

    getDetailsForPO(props: {
        id: number;
    }) {
        return this.fetcher.get<Keying2Config | null>("/api/keying2/for-po", props);
    }

    listLibraryEntries() {
        return this.fetcher.get<LibraryEntry[]>("/api/keying2/label-library");
    }

    upsertLibraryEntry(input: LibraryEntry) {
        return this.fetcher.post<LibraryEntry>("/api/keying2/label-library", input);
    }

    applyLibrary(input: {
        project: number;
        labels: Keying2Label[];
        shortcodeNames: string[];
    }) {
        return this.fetcher.post("/api/keying2/apply-library", input);
    }

    copyFromProject(input: {
        project: number;
        from: number;
    }) {
        return this.fetcher.post("/api/keying2/copy-from-project", input);
    }

    setBaseBuilding(input: {
        project: number;
        baseBuildingProject: number | null;
    }) {
        return this.fetcher.post("/api/keying2/base-building", input);
    }
}

export type LibraryEntry = {
    id: number;
    name: string;
    title: string;
    description: string;
    archived: boolean;
    updatedAt: string;
}

export type Keying2Label = {
    name: string;
    title: string;
    oldName?: string; // for rename
    description: string;
    keyCount: number;
}

export type Keying2Config = {
    id: number;
    project: number;
    enabled: boolean;
    labelsAvailable?: Keying2Label[];
    quoteNotes: string;
    baseBuildingProject?: number | null;
    baseBuildingProjectName?: string | null;
    createdAt: string;
    updatedAt: string;
    shortcodes?: Keying2Shortcode[];
}

export type Keying2Shortcode = {
    id: number;
    project: number;
    name: string;
    createdAt: string;
    updatedAt: string;
    archived: boolean;
    logisticsMode: "factory-key" | "on-site";
    baseBuildingOpenings?: number[];
    openings?: Keying2Opening[];
    miscItems?: Keying2MiscItem[];
    products?: Keying2Product[];
}

export type Keying2Product = {
    id: number;
    project: number;
    shortcode: number;
    product?: number | null;
    productCategory?: string | null;
    productCode?: string | null;
    qtyMeta: Keying2QtyMeta[];
    openingPart?: OpeningType | null;
    byOthers: boolean;
    labelsSelected: string[]; // label name
    createdAt: string;
    updatedAt: string;
    archived: boolean;
}

export type Keying2QtyMeta = {
    opening?: number | null;
    miscProduct?: number | null;
    name: string;
    qty: number;
}

export type Keying2Opening = {
    id: number;
    name: string;
    floor: string;
    locationTwo: string;
    seqNumber: number;
    openingType: string;
    keyed: boolean;
    baseBuilding?: boolean;
    baseBuildingMissing?: boolean;
}

export type Keying2MiscItem = {
    id: number;
    name: string;
    qty: number;
}

export type Keying2PendingItem = {
    opening?: number | null;
    miscProduct?: number | null;
    name: string;
    locationTwo?: string | null;
    qty: number;
    isKeyed: boolean;
    baseBuilding?: boolean;
}
